module.exports = __webpack_public_path__ + "static/img/ewm1.71a985d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/img/ewm1.png
// module id = IpfJ
// module chunks = 23